import { useQuery } from "@tanstack/react-query";
import { getVitals } from "../api/vitals.api";
import { VitalRow } from "../api/vital.type";
import { useUserDetails } from "./useUserDetails";

function useLoadVitals(userId?: string) {
  const { userDetails } = useUserDetails();

  const { data: vitals = [], isLoading, error } = useQuery<VitalRow[]>({
    queryKey: ["vitals", userId || userDetails?.id],
    queryFn: () => getVitals(userId || userDetails?.id),
  });

  return { vitals, isLoading, error };
}

export default useLoadVitals;

